'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeDensitymapboxIcon = function TraceTypeDensitymapboxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement(
                'radialGradient',
                { id: 'a', cx: '36.94', cy: '20.41', r: '1', gradientUnits: 'userSpaceOnUse' },
                _react2.default.createElement('stop', { offset: '0', stopColor: '#269ffb' }),
                _react2.default.createElement('stop', { offset: '1', stopColor: '#1d9bfb', stopOpacity: '.1' })
            ),
            _react2.default.createElement('radialGradient', { id: 'b', cx: '22.42', cy: '20.41', r: '2', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'c', cx: '10.91', cy: '14.41', r: '1', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'd', cx: '15.92', cy: '24.42', r: '1', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'e', cx: '13.91', cy: '28.42', r: '1', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'f', cx: '25.93', cy: '27.42', r: '3', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'g', cx: '13.91', cy: '17.41', r: '1', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'h', cx: '20.92', cy: '26.42', r: '1', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'i', cx: '23.93', cy: '14.41', r: '1.5', xlinkHref: '#a' }),
            _react2.default.createElement('radialGradient', { id: 'j', cx: '30.93', cy: '20.41', r: '1', xlinkHref: '#a' })
        ),
        _react2.default.createElement('path', { fill: 'none', stroke: '#dfe8f3', d: 'M5.48 6.05h35.48v35.48H5.48zM5.48 11.22h35.48M5.48 16.4h35.48M5.48 21.08h35.48M5.48 26.25h35.48M5.48 31.43h35.48M5.48 36.6h35.48M10.65 41.44V5.96M15.83 41.53V6.05M20.51 41.53V6.05M25.68 41.53V6.05M30.86 41.53V6.05M36.03 41.53V6.05', strokeMiterlimit: '10', strokeWidth: '.25' }),
        _react2.default.createElement('path', { d: 'M0 0h46v46H0z', fill: 'none' }),
        _react2.default.createElement('path', { d: 'M31.48 28.3l-2.3 3.45-4.6 1.15-2.31-2.3h-3.45l-6.16 1.15-3.45-2.3 3.85-4.61v-3.45h5.17l4.19 3 4.46-3 9.21 6.91z', fill: '#25fdfc', stroke: '#fff', strokeMiterlimit: '10' }),
        _react2.default.createElement('path', { d: 'M36.09 28.3l-9.21-6.91-4.46 3-4.19-3h-5.17l-2.88-1.73v-2.3L9 16.21l-1.12 1.15-1.15-1.15V11.6H9l2.31-1.15h2.3l3.45 2.3h3.46l4.6-2.3 3.46 3.46-3.46 3.45h5.76v-2.3h3.45v1.15l1.15 1.15 1.15-1.15 3.46 3.45v3.46h-4zm-9.79 7.48l-1.15 1.15H24l.58-4-2.31-2.3h-3.45l-6.16 1.15 7.89 4v2.3l3.45 2.3h2.3l1.15-1.15v-2.3z', fill: '#25fdfc', stroke: '#fff', strokeMiterlimit: '10' }),
        _react2.default.createElement('circle', { cx: '36.94', cy: '20.41', r: '1', fill: 'url(#a)' }),
        _react2.default.createElement('circle', { cx: '22.42', cy: '20.41', r: '2', fill: 'url(#b)' }),
        _react2.default.createElement('circle', { cx: '10.91', cy: '14.41', r: '1', fill: 'url(#c)' }),
        _react2.default.createElement('circle', { cx: '15.92', cy: '24.42', r: '1', fill: 'url(#d)' }),
        _react2.default.createElement('circle', { cx: '13.91', cy: '28.42', r: '1', fill: 'url(#e)' }),
        _react2.default.createElement('circle', { cx: '25.93', cy: '27.42', r: '3', fill: 'url(#f)' }),
        _react2.default.createElement('circle', { cx: '13.91', cy: '17.41', r: '1', fill: 'url(#g)' }),
        _react2.default.createElement('circle', { cx: '20.92', cy: '26.42', r: '1', fill: 'url(#h)' }),
        _react2.default.createElement('circle', { cx: '23.93', cy: '14.41', r: '1.5', fill: 'url(#i)' }),
        _react2.default.createElement('circle', { cx: '30.93', cy: '20.41', r: '1', fill: 'url(#j)' })
    );
};

exports.default = TraceTypeDensitymapboxIcon;